import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { TypographyStyle, GoogleFont } from 'react-typography'
import typography from '../utils/typography'

import './reset.css'
import './lightbox.css'

import {Site, Container} from './layouts'
import Header from './header'
import Footer from './footer'

class TemplateWrapper extends React.Component {
  render() {
    const {children, location} = this.props

    const isHome = location.pathname === '/'

    return (
      <Site>
        <TypographyStyle typography={typography} />
        <GoogleFont typography={typography} />
        <Helmet
          title="Kirsti Louko"
          meta={[
            { name: 'description', content: 'Kokonaisvaltaista hyvinvointia' },
            { name: 'keywords', content: 'psykoterapia, nettiterapia, työnohjaus, seksuaalineuvonta' },
          ]}
        />
        <Header isHome={isHome} />
        <Container>
          {children()}
        </Container>
        <Footer />
      </Site>
    )
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js